/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useGetNotesFileSystemInvalidator } from './use-get-notes-file-system';

/**
 * `Payload` type.
 */

type Payload = {
  itemId: string;
  newParentId: string | null | undefined;
  beforeId: string | null | undefined;
  afterId: string | null | undefined;
};

/**
 * Sort notes.
 */

async function sortNotes(client: AxiosInstance, data: Payload): Promise<void> {
  return await client({
    method: 'put',
    data,
    url: resolveAppUrl('appsNotes')
  });
}

/**
 * Export `usePostSortNotes`.
 */

export function usePostSortNotes() {
  const client = useRequestProvider();
  const invalidator = useGetNotesFileSystemInvalidator();

  return useMutation({
    mutationFn: async (data: Payload) => {
      const result = await sortNotes(client, data);

      await invalidator();

      return result;
    },
    onSuccess: () => {
      // Nothing to do.
    }
  });
}
